export const myDohmPortalOrigin = (productOrigin: string): string =>
  productOrigin === 'https://identity-qa.frozensave-app.pages.dev'
    ? 'https://dohm-my-app-qa.lucky-thunder-323b.workers.dev'
    : 'https://app.mydohm.com';
